var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrid1By111(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120,
    height: 80,
    viewBox: "0 0 120 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Grid_1_1-1-1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 80
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grid_1_1-1-1",
    "data-name": "Grid 1/1-1-1",
    clipPath: "url(#clip-Grid_1_1-1-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2142",
    "data-name": "Group 2142"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2075",
    "data-name": "Group 2075",
    transform: "translate(-1092 583)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_1",
    "data-name": 1,
    transform: "translate(1134 -515)",
    fontSize: 12,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1/1-1-1")), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_938",
    "data-name": "Rectangle 938",
    d: "M6,1A5.006,5.006,0,0,0,1,6V74a5.006,5.006,0,0,0,5,5H114a5.006,5.006,0,0,0,5-5V6a5.006,5.006,0,0,0-5-5H6M6,0H114a6,6,0,0,1,6,6V74a6,6,0,0,1-6,6H6a6,6,0,0,1-6-6V6A6,6,0,0,1,6,0Z",
    transform: "translate(1092 -583)",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2139",
    "data-name": "Group 2139"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2085",
    "data-name": "Group 2085",
    transform: "translate(-1247.515 -121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2084",
    "data-name": "Group 2084",
    transform: "translate(-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2063",
    "data-name": "Group 2063",
    transform: "translate(1279.515 144)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_786",
    "data-name": "Rectangle 786",
    d: "M2,1.5a.5.5,0,0,0-.5.5V14a.5.5,0,0,0,.5.5H64a.5.5,0,0,0,.5-.5V2a.5.5,0,0,0-.5-.5H2M2,0H64a2,2,0,0,1,2,2V14a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Line_25",
    "data-name": "Line 25",
    d: "M.75,15H-.75V0H.75Z",
    transform: "translate(47.75 23.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_25-2",
    "data-name": "Line 25",
    d: "M.75,15H-.75V0H.75Z",
    transform: "translate(70.75 23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_25-3",
    "data-name": "Line 25",
    d: "M.75,19.5H-.75V0H.75Z",
    transform: "translate(47.5 31.5) rotate(90)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid1By111);
export default __webpack_public_path__ + "static/media/Grid1by1-1-1.733496c4fd64cc72042026d8bcb9009d.svg";
export { ForwardRef as ReactComponent };